import { jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminBackgroundTaskStatus } from '../enums/admin-background-task-status';
import { AdminBackgroundTaskType } from '../enums/admin-background-task-type';

@jsonObject
export class AdminBackgroundTaskCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      status: AdminBackgroundTaskStatus;
      type: AdminBackgroundTaskType;
      progress: number;
      createdAt: Date;
      updatedAt: Date;
      canBeDeleted: boolean;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get status(): AdminBackgroundTaskStatus {
    return this.data.status;
  }

  public get type(): AdminBackgroundTaskType {
    return this.data.type;
  }

  public get progress(): number {
    return this.data.progress;
  }

  public get isUndefinedProgress(): boolean {
    return -1 === this.data.progress;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get updatedAt(): Date {
    return this.data.updatedAt;
  }

  public get canBeDeleted(): boolean {
    return this.data.canBeDeleted;
  }
}
